import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { EmbedStatusCardController } from './EmbedStatusCard.controller'
import { FC } from 'react'

/**
 * Page representing the Propstack embed status card surface (ISSUE-2018).
 *
 * Unlike the purchase-flow embed this needs none of the purchase-flow providers: it only wraps the
 * controller in the theme so the embedded iframe renders on-brand.
 *
 * @example <EmbedStatusCard />
 */
export const EmbedStatusCard: FC = () => (
  <BKBNThemeWrapper>
    <EmbedStatusCardController />
  </BKBNThemeWrapper>
)

export default EmbedStatusCard
